import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function SavePhoneSuccessToast(props: Props) {
  const { id } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t(
        "toasts.save_phone_success.body",
      )}
      id={id}
    />
  )
}
